import PS5 from "../../../images/Characteristics/ps5.webp";
import PS4 from "../../../images/Characteristics/ps4_pro.webp";
import xboxX from "../../../images/Characteristics/xbox_x.webp";
import xboxS from "../../../images/Characteristics/xbox_s.webp";
import ps5slim from "../../../images/Characteristics/ps5slim.webp";
import quest3 from "../../../images/Characteristics/quest3.webp";

export const consoles = [{
        name: ' PlayStation 5',
        image: PS5,
        gamepadsQuantity: '2 DualSense',
        resolution: 'До 4K з покращеннями',
        ssdVolume: '825 ГБ SSD',
        gameLibrary: 'Ексклюзиви для PS4Pro',
        Support: 'Так (PS4, PS3 через PSN)'
    },
    {
        name: ' PlayStation 4 Pro',
        image: PS4,
        gamepadsQuantity: '2 DualShock 4',
        resolution: 'До 4K',
        ssdVolume: '1000 ГБ HDD',
        gameLibrary: 'Більше 1000 ігор',
        Support: 'Так (PS4)'
    },
    {
        name: 'Xbox Series X',
        image: xboxX,
        gamepadsQuantity: '2 Xbox Wireless',
        resolution: 'До 4K',
        ssdVolume: '1000 ГБ SSD',
        gameLibrary: 'Доступ до Xbox Game Pass',
        Support: 'Так (Xbox One, 360)'
    },{
        name: 'Xbox Series S',
        image: xboxS,
        gamepadsQuantity: '2 Xbox Wireless',
        resolution: 'До 1440p',
        ssdVolume: '512 ГБ SSD',
        gameLibrary: 'Доступ до Xbox Game Pass',
        Support: 'Так (Xbox One, 360)'
    },
    {
        name: 'PlayStation 5 Slim',
        image: ps5slim,
        gamepadsQuantity: '2 DualSense',
        resolution: 'До 4K з покращеннями',
        ssdVolume: '1000 ГБ SSD',
        gameLibrary: 'Ексклюзиви для PS4Pro',
        Support: 'Так (PS4, PS3 через PSN)'
    },
    {
        name: 'Meta Quest 3 512GB',
        image: quest3,
        gamepadsQuantity: '2 контролера Meta QuestTouch Plus',
        resolution: '4K на кожне око',
        ssdVolume: '512 ГБ SSD',
        gameLibrary: 'Більше 500 ігор',
        Support: 'Так (Quest 2)'
    },]